<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-select
            v-model="grade"
            :items="gradeSelect"
            :rules="gradeRules"
            label="ระดับชั้น"
            required
          ></v-select>
        </v-col>

        <v-dialog
          v-model="announceVisible"
          transition="dialog-bottom-transition"
          persistent
          max-width="800"
        >
          <template v-slot:default="announce">
            <v-card>
              <v-toolbar color="blue" dark>ประกาศสำคัญ</v-toolbar>
              <v-card-text>
                <v-img
                  class="mb-4 mt-6 mx-auto"
                  contain
                  src="@/assets/announce.png"
                />
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  class="mx-auto"
                  @click="announce.value = false"
                  ><v-icon left> mdi-close </v-icon>ปิด</v-btn
                >
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>

        <v-col cols="12" md="4">
          <v-select
            v-model="prefix"
            :items="prefixSelect"
            :rules="prefixRules"
            label="คำนำหน้า"
            required
          ></v-select>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="name"
            :rules="nameRules"
            label="ชื่อ"
            hint="* กรอกชื่อภาษาไทย"
            persistent-hint
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="lastname"
            :rules="lastnameRules"
            label="นามสกุล"
            hint="* กรอกนามสกุลภาษาไทย หากไม่มีเว้นว่างไว้"
            persistent-hint
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-dialog
            ref="birthdayDialog"
            v-model="birthdaySelect"
            :return-value.sync="birthday"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="birthdayFormatted"
                label="วันเกิด"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="birthdayRules"
                hint="* วัน/เดือน/ปีพุทธศักราช"
                persistent-hint
                required
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              v-model="birthday"
              locale="th"
              :max="new Date().toISOString().substr(0, 10)"
              min="2000-01-01"
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="birthdaySelect = false">
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.birthdayDialog.save(birthday)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="oldschool"
            :rules="oldschoolRules"
            label="โรงเรียนที่จบการศึกษา"
            hint="* ก่อนหน้านี้"
            persistent-hint
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="idcard"
            :rules="idcardRules"
            label="หมายเลขบัตรประชาชน 13 หลัก"
            v-mask="'#-####-#####-##-#'"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="nameFather"
            :rules="nameParentsRules"
            label="ชื่อ-นามสกุล บิดา"
            hint="* กรอกคำนำหน้า ชื่อ-นามสกุลของบิดา ภาษาไทย"
            persistent-hint
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="nameMother"
            :rules="nameParentsRules"
            label="ชื่อ-นามสกุล มารดา"
            hint="* กรอกคำนำหน้า ชื่อ-นามสกุลของมารดา ภาษาไทย"
            persistent-hint
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="nameParents"
            :rules="nameParentsRules"
            label="ชื่อ-นามสกุล ผู้ปกครอง"
            hint="* กรอกคำนำหน้า ชื่อ-นามสกุลของผู้ปกครอง ภาษาไทย"
            persistent-hint
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="phone1"
            :rules="phone1Rules"
            v-mask="'##-####-####'"
            label="เบอร์โทรศัพท์หมายเลขที่ 1"
            hint="* กรอกเบอร์ที่สามารถติดต่อได้ง่าย"
            persistent-hint
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="phone2"
            :rules="phone2Rules"
            v-mask="'##-####-####'"
            label="เบอร์โทรศัพท์หมายเลขที่ 2"
            hint="* กรอกเบอร์ติดต่อสำรอง หากไม่มีเว้นว่างไว้"
            persistent-hint
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="address"
            :rules="addressRules"
            label="ที่อยู่ (ตามทะเบียนบ้าน)"
            hint="* กรอกทะเบียนบ้านปัจจุบัน (บ้านเลขที่ หมู่ ซอย ถนน)"
            persistent-hint
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <v-alert border="top" colored-border type="error" elevation="2">
            ข้อมูลถัดไปกรอกแค่รหัสไปรษณีย์ที่อยู่ตามทะเบียนบ้านปัจจุบันของนักเรียน
            จากนั้นเลือกข้อมูล ระบบจะทำการกรอกข้อมูลให้นักเรียนโดยอัตโนมัติ
          </v-alert>
        </v-col>

        <v-col cols="12">
          <ThailandAutoComplete
            v-model="zipcode"
            type="zipcode"
            @select="zipcodeSelect"
            color="#03A9F4"
            v-mask="'#####'"
            placeholder="รหัสไปรษณีย์"
          />
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="subdistrict"
            :rules="subdistrictRules"
            label="ตำบล / แขวง"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="district"
            :rules="districtRules"
            label="อำเภอ / เขต"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="province"
            :rules="provinceRules"
            label="จังหวัด"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="12" v-if="dateaddressShow && gradeToggle">
          <v-dialog
            ref="dateaddressDialog"
            v-model="dateaddressSelect"
            :return-value.sync="dateaddress"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateaddressFormatted"
                label="วันที่ย้ายเข้ามาอยู่ในทะเบียนบ้าน"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="dateaddressRules"
                hint="* ระบุวันที่นักเรียนย้ายเข้ามาอยู่ในทะเบียนบ้านปัจจุบันตามรายการบุคคลในบ้าน ตรงหัวข้อ 'เข้ามาอยู่ในบ้านนี้เมื่อ 3 พ.ค. 2548' (ตัวอย่าง)
                วัน/เดือน/ปีพุทธศักราช"
                persistent-hint
                required
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              v-model="dateaddress"
              locale="th"
              :max="new Date().toISOString().substr(0, 10)"
              min="2000-01-01"
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dateaddressSelect = false">
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dateaddressDialog.save(dateaddress)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col cols="12" v-if="dateaddressShow && gradeToggle">
          <v-img
            class="mx-auto"
            contain
            max-height="300"
            max-width="300"
            src="@/assets/exaddress.jpg"
          />
        </v-col>

        <v-col cols="12" v-if="oldaddressShow && gradeToggle">
          <v-text-field
            v-model="oldaddress"
            :rules="oldaddressRules"
            label="ที่อยู่ (ตามทะเบียนบ้านก่อนหน้านี้)"
            hint="* กรอกทะเบียนบ้านก่อนหน้านี้ (บ้านเลขที่ หมู่ ซอย ถนน)"
            persistent-hint
          ></v-text-field>
        </v-col>

        <v-col cols="12" v-if="oldaddressShow && gradeToggle">
          <v-alert border="top" colored-border type="error" elevation="2">
            ขอตรวจสอบทะเบียนบ้านเดิม
            ก่อนย้ายมาทะเบียนบ้านปัจจุบันเนื่องจากย้ายเข้ามาไม่ถึง 2 ปี
          </v-alert>
        </v-col>

        <v-col cols="12" v-if="oldaddressShow && gradeToggle">
          <ThailandAutoComplete
            v-model="oldzipcode"
            type="zipcode"
            @select="oldzipcodeSelect"
            color="#03A9F4"
            v-mask="'#####'"
            placeholder="รหัสไปรษณีย์"
          />
        </v-col>

        <v-col cols="12" md="4" v-if="oldaddressShow && gradeToggle">
          <v-text-field
            v-model="oldsubdistrict"
            :rules="oldsubdistrictRules"
            label="ตำบล / แขวง"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4" v-if="oldaddressShow && gradeToggle">
          <v-text-field
            v-model="olddistrict"
            :rules="olddistrictRules"
            label="อำเภอ / เขต"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4" v-if="oldaddressShow && gradeToggle">
          <v-text-field
            v-model="oldprovince"
            :rules="oldprovinceRules"
            label="จังหวัด"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="12" v-if="gradeToggle">
          <v-radio-group v-model="area" column>
            <v-radio
              label="นักเรียนอยู่ในเขตพื้นที่บริการ"
              color="info"
              value="true"
              readonly
            ></v-radio>
            <v-radio
              label="นักเรียนอยู่นอกเขตพื้นที่บริการ"
              color="info"
              value="false"
              readonly
            ></v-radio>
          </v-radio-group>
        </v-col>

        <v-col cols="12" md="4" v-if="gradeToggle == false">
          <v-select
            v-model="plan1"
            :items="plan1Select"
            :rules="plan1Rules"
            label="แผนการเรียนที่ต้องการลำดับที่ 1"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="4" v-if="gradeToggle == false">
          <v-select
            v-model="plan2"
            :items="plan2Select"
            :rules="plan2Rules"
            label="แผนการเรียนที่ต้องการลำดับที่ 2"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="4" v-if="gradeToggle == false">
          <v-select
            v-model="plan3"
            :items="plan3Select"
            :rules="plan3Rules"
            label="แผนการเรียนที่ต้องการลำดับที่ 3"
            required
          ></v-select>
        </v-col>

        <v-col cols="12">
          <v-checkbox
            v-model="agreement"
            :rules="agreementRules"
            label="ข้าพเจ้าขอยืนยันว่า ข้อมูลดังกล่าวข้างต้นเป็นความจริงทุกประการ ข้าพเจ้าได้ตรวจสอบครบถ้วนเรียบร้อยแล้ว"
            required
          ></v-checkbox>
        </v-col>

        <v-col cols="12">
          <v-btn
            :disabled="!valid"
            color="success"
            class="mr-4"
            @click="validate"
            :style="{ left: '50%', transform: 'translateX(-50%)' }"
          >
            สมัครเรียน
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    valid: true,

    grade: null,
    gradeToggle: null,
    gradeSelect: ["มัธยมศึกษาปีที่ 1", "มัธยมศึกษาปีที่ 4"],
    gradeRules: [(v) => !!v || "เลือกระดับชั้นที่ต้องการสมัคร"],

    announceVisible: false,

    prefix: null,
    prefixSelect: ["เด็กชาย", "เด็กหญิง", "นาย", "นางสาว"],
    prefixRules: [(v) => !!v || "กรอกคำนำหน้าชื่อ"],

    name: "",
    nameRules: [
      (v) =>
        (!!v && /^[ก-๙\s]+$/.test(v) && v.substring(0, 1) !== " ") ||
        "กรอกชื่อ โดยใช้ภาษาไทย",
    ],

    lastname: "",
    lastnameRules: [
      (v) =>
        !v ||
        (/^[ก-๙\s]+$/.test(v) && v.substring(0, 1) !== " ") ||
        "กรอกนามสกุล โดยใช้ภาษาไทย",
    ],

    birthday: null,
    birthdaySelect: false,
    birthdayRules: [(v) => !!v || "ระบุวันเกิด"],

    oldschool: "",
    oldschoolRules: [
      (v) =>
        (!!v &&
          /^[ก-๙\s.]+$/.test(v) &&
          v.substring(0, 1) !== " " &&
          v.substring(0, 1) !== ".") ||
        "กรอกโรงเรียนที่จบการศึกษาก่อนหน้านี้ โดยใช้ภาษาไทย",
    ],

    idcard: "",
    idcardRules: [
      (v) => !!v || "กรอกหมายเลขบัตรประจำตัวประชาชน 13 หลัก",
      (v) => v.length >= 17 || "กรอกหมายเลขบัตรประจำตัวประชาชนให้ครบ 13 หลัก",
    ],

    nameFather: "",
    nameMother: "",
    nameParents: "",
    nameParentsRules: [
      (v) =>
        (!!v &&
          /^[ก-๙\s.]+$/.test(v) &&
          v.substring(0, 1) !== " " &&
          v.substring(0, 1) !== ".") ||
        "กรอกชื่อ โดยใช้ภาษาไทย",
    ],

    phone1: "",
    phone1Rules: [
      (v) => !!v || "กรอกเบอร์โทรศัพท์ที่ติดต่อได้หมายเลขที่ 1",
      (v) =>
        v.length >= 12 ||
        "กรอกเบอร์โทรศัพท์ที่ติดต่อได้หมายเลขที่ 1 ให้ครบ 10 หลัก",
    ],
    phone2: "",
    phone2Rules: [
      (v) =>
        v.length >= 12 ||
        !v ||
        "กรอกเบอร์โทรศัพท์ที่ติดต่อได้หมายเลขที่ 1 ให้ครบ 10 หลัก",
    ],

    zipcode: "",
    address: "",
    addressRules: [
      (v) =>
        (!!v && v.substring(0, 1) !== " ") ||
        "กรอกที่อยู่ตามทะเบียนบ้านของนักเรียน",
    ],
    subdistrict: "",
    subdistrictRules: [
      (v) =>
        !!v ||
        "กรอกเพียงรหัสไปรษณีย์ตามที่อยู่ทะเบียนบ้านของนักเรียนในปัจจุบัน จากนั้นเลือกข้อมูลระบบจะทำการกรอกตำบล / แขวง ตามที่ท่านเลือกให้โดยอัตโนมัติ",
    ],
    district: "",
    districtRules: [
      (v) =>
        !!v ||
        "กรอกเพียงรหัสไปรษณีย์ตามที่อยู่ทะเบียนบ้านของนักเรียนในปัจจุบัน จากนั้นเลือกข้อมูลระบบจะทำการกรอกอำเภอ / เขต ตามที่ท่านเลือกให้โดยอัตโนมัติ",
    ],
    province: "",
    provinceRules: [
      (v) =>
        !!v ||
        "กรอกเพียงรหัสไปรษณีย์ตามที่อยู่ทะเบียนบ้านของนักเรียนในปัจจุบัน จากนั้นเลือกข้อมูลระบบจะทำการกรอกจังหวัด ตามที่ท่านเลือกให้โดยอัตโนมัติ",
    ],

    dateaddress: null,
    dateaddressShow: null,
    dateaddressSelect: false,
    dateaddressRules: [
      (v) =>
        !!v ||
        "ระบุวันที่นักเรียนย้ายเข้ามาอยู่ในทะเบียนบ้านปัจจุบัน ตามรายการบุคคลในบ้าน ตรงหัวข้อ 'เข้ามาอยู่ในบ้านนี้เมื่อ 3 พ.ค. 2548' (ตัวอย่าง)",
    ],

    oldaddressShow: null,
    oldzipcode: "",
    oldaddress: "",
    oldaddressRules: [
      (v) =>
        (!!v && v.substring(0, 1) !== " ") ||
        "กรอกที่อยู่ตามทะเบียนบ้านของนักเรียนก่อนหน้านี้",
    ],
    oldsubdistrict: "",
    oldsubdistrictRules: [
      (v) =>
        !!v ||
        "กรอกเพียงรหัสไปรษณีย์ตามที่อยู่ทะเบียนบ้านของนักเรียน จากนั้นเลือกข้อมูลระบบจะทำการกรอกตำบล / แขวง ตามที่ท่านเลือกให้โดยอัตโนมัติ",
    ],
    olddistrict: "",
    olddistrictRules: [
      (v) =>
        !!v ||
        "กรอกเพียงรหัสไปรษณีย์ตามที่อยู่ทะเบียนบ้านของนักเรียนก่อนหน้านี้ จากนั้นเลือกข้อมูลระบบจะทำการกรอกอำเภอ / เขต ตามที่ท่านเลือกให้โดยอัตโนมัติ",
    ],
    oldprovince: "",
    oldprovinceRules: [
      (v) =>
        !!v ||
        "กรอกเพียงรหัสไปรษณีย์ตามที่อยู่ทะเบียนบ้านของนักเรียนก่อนหน้านี้ จากนั้นเลือกข้อมูลระบบจะทำการกรอกจังหวัด ตามที่ท่านเลือกให้โดยอัตโนมัติ",
    ],

    area: null,

    plan1: null,
    plan1Select: [
      "วิทยาศาสตร์-คณิตศาสตร์",
      "ภาษาอังกฤษ-คณิตศาสตร์",
      "ภาษาอังกฤษ-ภาษาจีน",
      "ภาษาอังกฤษ-ภาษาญี่ปุ่น",
      "ศิลป์-ภาษาอังกฤษ",
      "ศิลป์-การงานอาชีพ",
    ],
    plan1Rules: [(v) => !!v || "เลือกแผนการเรียนที่ต้องการลำดับที่ 1"],
    plan2: null,
    plan2Select: [
      "วิทยาศาสตร์-คณิตศาสตร์",
      "ภาษาอังกฤษ-คณิตศาสตร์",
      "ภาษาอังกฤษ-ภาษาจีน",
      "ภาษาอังกฤษ-ภาษาญี่ปุ่น",
      "ศิลป์-ภาษาอังกฤษ",
      "ศิลป์-การงานอาชีพ",
    ],
    plan2Rules: [(v) => !!v || "เลือกแผนการเรียนที่ต้องการลำดับที่ 1 ก่อน"],
    plan3: null,
    plan3Select: [
      "วิทยาศาสตร์-คณิตศาสตร์",
      "ภาษาอังกฤษ-คณิตศาสตร์",
      "ภาษาอังกฤษ-ภาษาจีน",
      "ภาษาอังกฤษ-ภาษาญี่ปุ่น",
      "ศิลป์-ภาษาอังกฤษ",
      "ศิลป์-การงานอาชีพ",
    ],
    plan3Rules: [(v) => !!v || "เลือกแผนการเรียนที่ต้องการลำดับที่ 2 ก่อน"],

    agreement: false,
    agreementRules: [(v) => !!v || "คุณจำเป็นต้องยอมรับข้อตกลงนี้"],
  }),
  computed: {
    birthdayFormatted() {
      return this.formatDate(this.birthday);
    },
    dateaddressFormatted() {
      return this.formatDate(this.dateaddress);
    },
  },
  watch: {
    grade(val) {
      if (val && val == "มัธยมศึกษาปีที่ 1") {
        this.resetVar("M4");
        this.gradeToggle = true;
      } else {
        this.resetVar("M1");
        this.gradeToggle = false;
        this.announceVisible = true;
      }
    },
    birthdaySelect(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    dateaddressSelect(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    dateaddress(val) {
      if (val) {
        const [year, month, day] = val.split("-");
        if (
          (543 + +year <= 2563 && 543 + +year !== 2563) ||
          (month < 5 && 543 + +year == 2563) ||
          (day < 16 && month == 5 && 543 + +year == 2563)
        ) {
          this.area = "true";

          this.oldaddress = "";
          this.oldsubdistrict = "";
          this.olddistrict = "";

          this.oldaddressShow = false;
        } else {
          if (val) {
            this.area = null;
            this.oldaddressShow = true;

            this.oldaddress = "";
            this.oldsubdistrict = "";
            this.olddistrict = "";
          } else {
            this.area = "false";
            this.dateaddress = null;
            this.oldaddress = "";
            this.oldsubdistrict = "";
            this.olddistrict = "";
          }
        }
      }
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${543 + +year}`;
    },
    zipcodeSelect(address) {
      this.subdistrict = address.district;
      this.district = address.amphoe;
      this.province = address.province;
      this.zipcode = address.zipcode;

      if (
        (this.subdistrict == "หนองแก" && this.district == "หัวหิน") ||
        (this.subdistrict == "หัวหิน" && this.district == "หัวหิน") ||
        (this.subdistrict == "หินเหล็กไฟ" && this.district == "หัวหิน") ||
        (this.subdistrict == "ทับใต้" && this.district == "หัวหิน")
      ) {
        this.dateaddressShow = true;
        this.area = null;
      } else {
        this.dateaddressShow = false;
        this.area = "false";

        this.dateaddress = null;
        this.oldzipcode = "";
        this.oldaddress = "";
        this.oldsubdistrict = "";
        this.olddistrict = "";
      }
    },
    oldzipcodeSelect(oldaddress) {
      this.oldsubdistrict = oldaddress.district;
      this.olddistrict = oldaddress.amphoe;
      this.oldprovince = oldaddress.province;
      this.oldzipcode = oldaddress.zipcode;

      if (
        (this.oldsubdistrict == "หนองแก" && this.olddistrict == "หัวหิน") ||
        (this.oldsubdistrict == "หัวหิน" && this.olddistrict == "หัวหิน") ||
        (this.oldsubdistrict == "หินเหล็กไฟ" && this.olddistrict == "หัวหิน") ||
        (this.oldsubdistrict == "ทับใต้" && this.olddistrict == "หัวหิน")
      ) {
        this.area = "true";
      } else {
        this.area = "false";
      }
    },
    resetVar(mode) {
      const resetValM1 = () => {
        this.dateaddress = null;
        this.oldzipcode = "";
        this.oldsubdistrict = "";
        this.olddistrict = "";
        this.area = null;
      };
      const resetValM4 = () => {
        this.plan1 = null;
        this.plan2 = null;
        this.plan3 = null;
      };

      this.agreement = false;
      if (mode == "M4") {
        resetValM1();
      } else if (mode == "M1") {
        resetValM4();
      } else {
        this.grade = null;
        this.prefix = null;
        this.name = "";
        this.lastname = "";
        this.birthday = null;
        this.oldschool = "";
        this.idcard = "";
        this.nameFather = "";
        this.nameMother = "";
        this.nameParents = "";
        this.phone1 = "";
        this.phone2 = "";
        this.zipcode = "";
        this.address = "";
        this.subdistrict = "";
        this.district = "";
        this.province = "";

        resetValM1();
        resetValM4();
      }
    },
    validate() {
      const showErrorAlert = (html, mode) => {
        this.valid = true;
        if (mode == "again") {
          return this.$swal({
            icon: "error",
            title: "พบข้อผิดพลาด",
            confirmButtonText: "รับทราบ",
            confirmButtonColor: "#03A9F4",
            html: `${html} <br>กรุณาแก้ไขแล้วกดสมัครเรียนอีกครั้ง`,
          });
        } else {
          return this.$swal({
            icon: "error",
            title: "พบข้อผิดพลาด",
            confirmButtonText: "รับทราบ",
            confirmButtonColor: "#03A9F4",
            html: `${html} <br>กรุณาลองใหม่อีกครั้งภายหลัง`,
          });
        }
      };
      const showSuccessAlert = (html) => {
        this.$swal({
          icon: "success",
          title: "ยินดีด้วย",
          confirmButtonText: "รับทราบ",
          confirmButtonColor: "#03A9F4",
          html: `${html}`,
        }).then(() => {
          this.resetVar();
          this.valid = true;
          this.$router.push("/List");
        });
      };

      if (this.$refs.form.validate()) {
        this.valid = false;
        if (this.phone1 == this.phone2) {
          this.valid = true;
          return showErrorAlert(
            "เบอร์หมายเลขที่ 1 ซ้ำกับเบอร์หมายเลขที่ 2",
            "again"
          );
        }
        if (
          this.address == this.oldaddress &&
          this.grade == "มัธยมศึกษาปีที่ 1"
        ) {
          this.valid = true;
          return showErrorAlert(
            "ที่อยู่ซ้ำกับที่อยู่ปัจจุบัน <br>กรอกที่อยู่ตามทะเบียนบ้านของนักเรียนก่อนหน้านี้",
            "again"
          );
        }
        if (
          (this.plan1 == this.plan2 && this.grade == "มัธยมศึกษาปีที่ 4") ||
          (this.plan1 == this.plan3 && this.grade == "มัธยมศึกษาปีที่ 4") ||
          (this.plan2 == this.plan3 && this.grade == "มัธยมศึกษาปีที่ 4")
        ) {
          this.valid = true;
          return showErrorAlert("เลือกแผนการเรียนซ้ำกัน", "again");
        }
        if (this.nameFather == this.nameMother) {
          this.valid = true;
          return showErrorAlert("ชื่อบิดากับมารดาเหมือนกัน", "again");
        }

        if (this.grade == "มัธยมศึกษาปีที่ 4") {
          this.valid = false;
          const dataStudent = JSON.stringify({
            prefix: this.prefix,
            name: this.name,
            lastname: this.lastname,
            birthday: this.formatDate(this.birthday),
            oldschool: this.oldschool,
            idcard: this.idcard,
            nameFather: this.nameFather,
            nameMother: this.nameMother,
            nameParents: this.nameParents,
            phone1: this.phone1,
            phone2: this.phone2,
            zipcode: this.zipcode,
            address: this.address,
            subdistrict: this.subdistrict,
            district: this.district,
            province: this.province,

            plan1: this.plan1,
            plan2: this.plan2,
            plan3: this.plan3,
          });
          axios
            .post(
              "https://huahin.ac.th/service/hhreg/api/create.php?grade=m4",
              dataStudent
            )
            .then((response) => {
              if (response) {
                showSuccessAlert(
                  `ลงทะเบียน <br>${this.prefix}${this.name} ${this.lastname} <br>สำเร็จ`
                );
              }
            })
            .catch((error) => {
              if (error.response) {
                showErrorAlert(error.response.data.message);
              }
            });
        } else if (this.area == "true") {
          this.valid = false;
          const dataStudent = JSON.stringify({
            prefix: this.prefix,
            name: this.name,
            lastname: this.lastname,
            birthday: this.formatDate(this.birthday),
            oldschool: this.oldschool,
            idcard: this.idcard,
            nameFather: this.nameFather,
            nameMother: this.nameMother,
            nameParents: this.nameParents,
            phone1: this.phone1,
            phone2: this.phone2,
            zipcode: this.zipcode,
            address: this.address,
            subdistrict: this.subdistrict,
            district: this.district,
            province: this.province,
            dateaddress: this.formatDate(this.dateaddress),
            oldzipcode: this.oldzipcode,
            oldaddress: this.oldaddress,
            oldsubdistrict: this.oldsubdistrict,
            olddistrict: this.olddistrict,
            oldprovince: this.oldprovince,
          });
          axios
            .post(
              "https://huahin.ac.th/service/hhreg/api/create.php?grade=area",
              dataStudent
            )
            .then((response) => {
              if (response) {
                showSuccessAlert(
                  `ลงทะเบียนสำเร็จแล้ว <br>${this.prefix}${this.name} ${this.lastname} <br>เป็นนักเรียนในเขตพื้นที่บริการ`
                );
              }
            })
            .catch((error) => {
              if (error.response) {
                showErrorAlert(error.response.data.message);
              }
            });
        } else if (this.area == "false") {
          this.valid = false;
          const dataStudent = JSON.stringify({
            prefix: this.prefix,
            name: this.name,
            lastname: this.lastname,
            birthday: this.formatDate(this.birthday),
            oldschool: this.oldschool,
            idcard: this.idcard,
            nameFather: this.nameFather,
            nameMother: this.nameMother,
            nameParents: this.nameParents,
            phone1: this.phone1,
            phone2: this.phone2,
            zipcode: this.zipcode,
            address: this.address,
            subdistrict: this.subdistrict,
            district: this.district,
            province: this.province,
            dateaddress: this.formatDate(this.dateaddress),
            oldzipcode: this.oldzipcode,
            oldaddress: this.oldaddress,
            oldsubdistrict: this.oldsubdistrict,
            olddistrict: this.olddistrict,
            oldprovince: this.oldprovince,
          });
          axios
            .post(
              "https://huahin.ac.th/service/hhreg/api/create.php?grade=outarea",
              dataStudent
            )
            .then((response) => {
              if (response) {
                showSuccessAlert(
                  `ลงทะเบียนสำเร็จแล้ว <br>${this.prefix}${this.name} ${this.lastname} <br>เป็นนักเรียนนอกเขตพื้นที่บริการ`
                );
              }
            })
            .catch((error) => {
              if (error.response) {
                showErrorAlert(error.response.data.message);
              }
            });
        }
      }
    },
  },
};
</script>

<style>
.v-text-field input,
.v-select__selections {
  line-height: 24px !important;
}

.v-text-field .v-label {
  overflow: visible !important;
  line-height: 26px !important;
}

.v-messages__message {
  line-height: 18px !important;
}

.v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.6 !important;
}
</style>
